"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTracksCountString = void 0;
const plural_ru_1 = __importDefault(require("plural-ru"));
function getTracksCountString(count) {
    return count !== 0
        ? (0, plural_ru_1.default)(count, '%d трек', '%d трека', '%d треков')
        : 'Нет треков';
}
exports.getTracksCountString = getTracksCountString;
